import { Box } from '@mui/material';
import NoteOptionsPanelToggles from './NoteOptionsPanelToggles';
import NoteOptionsPanelActions from './NoteOptionsPanelActions';

/**
 * @param {object} props
 * @param {object} props.entry
 * @param {boolean} props.isTemplate
 * @param {boolean} props.isJson
 * @param {function} props.onClose
 * @param {string} [props.panelId='default']
 */
export default function NoteOptionsPanelContent({ entry, isTemplate, isJson, onClose, panelId = 'default' }) {
    return (
        <Box sx={{ py: '4px' }}>
            <NoteOptionsPanelToggles entry={entry} isTemplate={isTemplate} isJson={isJson} panelId={panelId} />
            <NoteOptionsPanelActions entry={entry} onClose={onClose} panelId={panelId} />
        </Box>
    );
}
